import { Controller } from "@hotwired/stimulus"
import { aroundStreamRender } from "../helpers/stream_render"

// Keeps a scroll container's position across a turbo-stream that replaces an ancestor.
//
// The Zeitleiste answers every approval (row button, offcanvas decision) by replacing its
// whole content frame, so the scrolled grid body is thrown away and the new one starts at the
// top. This controller sits on the scroll container, notices a stream about to replace an
// element that contains it, and carries the position onto the container that comes back in the
// stream's target with the same key. The key names the grid: the timeline view is
// account-sticky, so it can change in another tab between two approvals, and one grid's offsets
// must never land on another.
//
// Morphing the frame instead (`method: :morph`) would keep the node and its scroll without any
// of this, but it also keeps every controller inside connected across the refresh —
// timeline-select sets selection mode up only in connect(), so an approval that ends the mode
// would leave it running.
//
//   <div class="overflow-auto" data-controller="scroll-keeper"
//        data-scroll-keeper-key-value="timeline-weekly">
export default class extends Controller {
  static values = { key: String }

  connect() {
    document.addEventListener("turbo:before-stream-render", this.onStreamRender)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.onStreamRender)
  }

  onStreamRender = (event) => {
    const stream = event.detail.newStream
    if (!stream.targetElements.some((target) => target.contains(this.element))) return

    aroundStreamRender(event, async (render) => {
      // Read at the swap, not at the event: Turbo waits for a repaint in between, and a scroll
      // in that window would otherwise be undone.
      const { scrollTop, scrollLeft } = this.element
      await render()

      const container = this.counterpartIn(stream.targetElements)
      if (!container) return

      container.scrollTop = scrollTop
      container.scrollLeft = scrollLeft
    })
  }

  counterpartIn(targets) {
    const selector = `[data-controller~="scroll-keeper"][data-scroll-keeper-key-value="${CSS.escape(this.keyValue)}"]`
    for (const target of targets) {
      const container = target.matches(selector) ? target : target.querySelector(selector)
      if (container) return container
    }
    return null
  }
}
